import ErrorIcon from '@mui/icons-material/ErrorOutline';
import { Helmet } from 'react-helmet-async';
import { BackLink } from '@/components/presentation/Back';
import { path } from '@/consts';
import styles from './style/Brand.NotFound.module.css';

export function BrandNotFound() {
  return (
    <div className={styles.root}>
      <div className={styles.wrap}>
        <Helmet title="Brand not found" />
        <div className={styles.icon}><ErrorIcon /></div>
        <div className={styles.copy}>Brand does not exist</div>
        <div className={styles.back}>
          <BackLink to={`${path.Home}`} />
        </div>
      </div>
    </div>
  );
}

BrandNotFound.displayName = 'Workspace.Brand.NotFound';